import React, { useState, useRef } from 'react';
import { CalendarIcon } from '@panwds/icons';
import { useOnOutsideClick, classNames, Select, Button, Portal, DateRangePicker } from '@panwds/react-ui';
import { ADVANCED_FILTER_BAR_MAX_CHARATER_LENGTH } from '../../utils/constants.esm.js';
import { LogQuery } from './LogQuery.esm.js';

function AdvancedFilterBar({ fields, dateRangeItems, onQuerySubmit, maxLength = ADVANCED_FILTER_BAR_MAX_CHARATER_LENGTH, queryString = "", showFilter = true, disabled = false, id = "advance-filterbar", }) {
    const [dateRange, setDateRange] = useState();
    const [resetClicked, setResetClicked] = useState(undefined);
    const [queryStr, setQueryStr] = useState(queryString);
    const [selectedItem, setSelectedItem] = useState(dateRangeItems[0]);
    const handleOnClickResetButton = () => {
        setResetClicked(!resetClicked);
        setSelectedItem(dateRangeItems[0]);
        setQueryStr(queryString);
    };
    const onQueryChange = (query) => {
        setQueryStr(query);
    };
    const onLogQuerySubmit = (query) => {
        onQuerySubmit(query, dateRange);
    };
    const [pickerIsOpen, setPickerIsOpen] = useState(false);
    const datePickerRef = useRef(null);
    useOnOutsideClick(datePickerRef, () => {
        setPickerIsOpen(false);
    });
    let defaultStyle = "tw-relative tw-z-20 tw-border-[1.5px] tw-border-solid tw-border-gray-300 tw-rounded before:tw-content-[''] before:tw-absolute before:tw-h-0 before:tw-w-0 before:tw-border-solid before:tw-border-transparent before:tw-border-8 after:tw-content-[''] after:tw-absolute after:tw-h-0 after:tw-w-0 after:tw-border-solid after:tw-border-transparent after:tw-border-8";
    defaultStyle = classNames(defaultStyle, "tw-top-3 tw-left-16 before:tw-left-6 before:tw--top-2 before:tw-border-t-0 before:tw-border-b-gray-300 dark:before:tw-border-b-gray-700 after:tw-left-6 after:tw-border-t-0 after:tw--top-1.5 after:tw-border-b-white dark:after:tw-border-b-gray-1000");
    return (React.createElement("div", { id: id }, showFilter && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tw-flex tw-flex-col" },
            React.createElement(Select, { dataMetrics: "filterbar-advance", dataTestId: "filterbar-advance", items: dateRangeItems, selectedItem: selectedItem, onChange: ({ selectedItem }) => {
                    if (selectedItem.value ===
                        dateRangeItems[dateRangeItems.length - 1].value) {
                        setPickerIsOpen(!pickerIsOpen);
                    }
                    else {
                        setPickerIsOpen(false);
                    }
                    setSelectedItem(selectedItem);
                }, button: React.createElement(Button, { icon: React.createElement(CalendarIcon, { size: "md" }), appearance: "tertiary", isMenu: true, addClassName: "tw-w-40 tw-justify-between" },
                    "Date: ", selectedItem === null || selectedItem === void 0 ? void 0 :
                    selectedItem.value) }),
            pickerIsOpen && (React.createElement(Portal, null,
                React.createElement("div", { className: classNames("tw-z-20 tw-w-96", defaultStyle), ref: datePickerRef },
                    React.createElement(DateRangePicker, { onApply: (nextDateRange) => {
                            setDateRange(nextDateRange);
                            setPickerIsOpen(false);
                        }, onCancel: () => setPickerIsOpen(false) }))))),
        React.createElement(LogQuery, { fields: fields, maxLength: maxLength, queryString: queryStr, onQueryChange: onQueryChange, onQuerySubmit: onLogQuerySubmit, disabled: disabled }),
        React.createElement(Button, { appearance: "tertiary-clear", onClick: handleOnClickResetButton }, "Reset")))));
}

export { AdvancedFilterBar };
//# sourceMappingURL=AdvancedFilterBar.esm.js.map
